import { API } from "../api";

const BASE_URL = "/members/communications/messages";

export const memberCommunicationApi = API.injectEndpoints({
  endpoints: (builder) => ({
    // Get member's messages (all messages where member is a recipient)
    // Note: member_id is not needed - backend gets it from authenticated token
    // Supports filtering by channel, date range, and read status
    getMemberMessages: builder.query({
      query: ({
        page = 1,
        limit = 20,
        channel = "all", // 'all', 'sms', 'email', 'both'
        from_date,
        to_date,
        is_read = "all", // 'all', 'true', 'false'
        search,
      }) => {
        const params = new URLSearchParams({
          guard: "member",
          page: page.toString(),
          limit: limit.toString(),
        });

        // Add optional filters
        if (channel && channel !== "all") {
          params.append("channel", channel);
        }
        if (from_date) {
          params.append("from_date", from_date);
        }
        if (to_date) {
          params.append("to_date", to_date);
        }
        if (is_read && is_read !== "all") {
          params.append("is_read", is_read);
        }
        if (search) {
          params.append("search", search);
        }

        return {
          url: `${BASE_URL}?${params.toString()}`,
        };
      },
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => {
        // Create tags for both the specific query params and a general LIST tag
        const tags = [{ type: "member-communication-messages", id: "LIST" }];
        // Also tag by is_read filter to help with cache invalidation
        if (arg?.is_read && arg.is_read !== "all") {
          tags.push({ type: "member-communication-messages", id: `LIST-${arg.is_read}` });
        }
        return tags;
      },
      cacheStrategy: "cache-and-network",
    }),

    // Get single message detail for member
    // Note: member_id is not needed - backend gets it from authenticated token
    getMemberMessageDetail: builder.query({
      query: (messageId) => ({
        url: `${BASE_URL}/${messageId}?guard=member`,
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => [
        { type: "member-communication-messages", id: arg },
        { type: "member-communication-messages", id: "LIST" },
      ],
    }),

    // Mark message as read
    markMessageAsRead: builder.mutation({
      query: (messageId) => ({
        url: `${BASE_URL}/${messageId}/mark-read?guard=member`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "member-communication-messages", id: arg },
        { type: "member-communication-messages", id: "LIST" },
        { type: "member-communication-messages", id: "LIST-false" }, // Invalidate unread messages list
        { type: "member-communication-messages", id: "LIST-true" }, // Invalidate read messages list
      ],
    }),
  }),
});

export const {
  useGetMemberMessagesQuery,
  useGetMemberMessageDetailQuery,
  useMarkMessageAsReadMutation,
} = memberCommunicationApi;
